import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';

export const useToggleBalance = () => {
    const dispatch = useDispatch();

    return useCallback((isHidden) => dispatch(actions.toggleBalance(isHidden)), [dispatch]);
};

